import React from 'react';
import { PropTypes } from 'prop-types';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import { LightTooltip } from '../../../../atoms/MTooltip/MTooltip';
import { palette } from '../../../../../theme/default';

const DialogLightTooltip = styled(LightTooltip)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: palette.common.white,
    color: palette.common.black,
    boxShadow: theme.shadows[1],
    padding: '14px',
    borderRadius: '8px',
  },
}));

const TooltipValue = ({ value }) => <Typography variant="bodyM">{value}</Typography>;
TooltipValue.propTypes = {
  value: PropTypes.string.isRequired,
};

export const ValueCell = ({ value }) => {
  return (
    <DialogLightTooltip
      title={<TooltipValue value={value} />}
      sx={{ zIndex: 10000 }}
      placement="top"
    >
      <Typography
        textTransform="none"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        overflow="hidden"
        variant="bodyM"
      >
        {value}
      </Typography>
    </DialogLightTooltip>
  );
};

ValueCell.propTypes = {
  value: PropTypes.string.isRequired,
};
